import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDropDown]',
  exportAs: 'appDropDown',
  host: {
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()'
  }
})
export class DropDownDirective {
  hover = false;

  constructor(public el: ElementRef) {}

  onMouseEnter() {
    this.el.nativeElement.classList.add('show');
  }

  onMouseLeave() {
    this.el.nativeElement.classList.remove('show');
  }
}
